import api from "./api";

// 숙소 리스트
export const lodListApi = async () => {
  const res = await api({
    method: "get",
    url: "lod/lodList",
  });

  return res;
};

//숙소정보 상세
export const lodInfApi = async ({ lodNo }: { lodNo: string }) => {
  const res = await api({
    method: "get",
    url: `lod/lodInfo/${lodNo}`,
  });

  return res;
};

//약관 조회
export const prvListapi = async () => {
  const res = await api({
    method: "get",
    url: `common/joinPrvList`,
  });

  return res;
};

//약관 상세
export const termDetailApi = async (prvCd: string) => {
  const res = await api({
    method: "get",
    url: `common/joinPrvDtl/${prvCd}`,
  });

  return res;
};

//프로모션코드 체크
export const chkPromCdApi = async (promCd: string) => {
  const res = await api({
    method: "get",
    url: `promotion/chkPromCd/${promCd}`,
  });

  return res;
};
